export default __webpack_public_path__ + "static/media/sword2.b505042a.svg";